module.exports = (s) => {
  return [
    {
      name: '时间',
      value: 'date',
      props: {
        width: 100,
        fixed: 'left',
      },
    },
    {
      name: '广告名称',
      value: 'promotion.name',
      props: {
        width: 100,
        fixed: 'left',
      },
    },
    {
      name: '推广目的',
      value: 'landing_type',
      format: ({ landing_type }) => {
        return landing_type;
      },
    },
    {
      name: '转化目标',
      value: 'external_action',
      format: ({ external_action }) => {
        return s.$store.getters.jrttEnumVal.api_2_ad_convert_type[external_action];
      },
    },
    {
      name: '计费类型',
      value: 'pricing_type',
    },
    {
      name: '平台',
      value: 'platform',
      format: ({ platform }) => {
        return s.$store.getters.jrttEnumVal.api_2_platforms[platform];
      },
    },
  ];
};
